interface Profile
{
	ID: number;
	CreatedAt: Date;
	LastEdited: Date | null;
	Title: string;
	Name: string;
	Surname: string;
	Birthday: Date | null;
	Gender: boolean;
	StaffNumber: string | null;
	Address: number[];
}

class ProfileManager
{
	private m_Profile: Profile;
	private m_Container: JQuery;
	private m_Inputs: JQuery[];

	constructor( person: any )
	{
		this.m_Profile =
		{
			ID: person.ID,
			Title: person.Title,
			Name: person.Name,
			Surname: person.Surname,
			Birthday: person.Birthday ? new Date( Date.parse( person.Birthday ) ) : null,
			StaffNumber: person.StaffNumber,
			Gender: person.Gender === "m",
			CreatedAt: new Date( Date.parse( person.CreatedAt ) ),
			LastEdited: person.LastEdited ? new Date( Date.parse( person.LastEdited ) ) : null,
			Address: person.Address
		};

		this.m_Container = $( ui.div() );

		this.m_Inputs = [];
	}

	public getInputs() : JQuery[]
	{
		return this.m_Inputs;
	}

	public getEditingFormular( inputs: boolean, buttons: boolean ): JQuery
	{
		return $( this.createForm( inputs, buttons ).getElement() );
	}

	private createForm( inputs: boolean, buttons: boolean ): Form
	{
		const form = new Form(
			{
				tag: 'div',
				orientation: 'horizontal'
			}
		);

		this.m_Inputs.push(
			form.newFormGroup( [ 1 ] ).addItem(
				{
					label: new InputLabel( { value: 'Erstellt am' } ),
					input: new InputStatic( 'created_at', this.m_Profile.CreatedAt.pattern( 'd.m.Y' ) )
				}
			)
		);

		this.m_Inputs.push(
			form.newFormGroup( [ 1 ] ).addItem(
				{
					label: new InputLabel( { value: 'Titel' } ),
					input: inputs ? new InputText( { name: 'title', value: this.m_Profile.Title, disabled: false, placeholder: 'Titel' } ) : new InputStatic( 'created_at', this.m_Profile.Title )
				}
			)
		);

		this.m_Inputs.push(
			form.newFormGroup( [ 1 ] ).addItem(
				{
					label: new InputLabel( { value: 'Name' } ),
					input: inputs ? new InputText( { name: 'surname', value: this.m_Profile.Surname, disabled: false, placeholder: 'Name' } ) : new InputStatic( 'created_at', this.m_Profile.Surname )
				}
			)
		);

		this.m_Inputs.push(
			form.newFormGroup( [ 1 ] ).addItem(
				{
					label: new InputLabel( { value: 'Vorname' } ),
					input: inputs ? new InputText( { name: 'name', value: this.m_Profile.Name, disabled: false, placeholder: 'Vorname' } ) : new InputStatic( 'created_at', this.m_Profile.Name )
				}
			)
		);

		this.m_Inputs.push(
			form.newFormGroup( [ 1 ] ).addItem(
				{
					label: new InputLabel( { value: 'Geschlecht' } ),
					input: inputs ? new InputSelect( { name: 'gender', classes: [ 'form-control' ] }, { männlich: 'm', weiblich: 'f' }, this.m_Profile.Gender ? 0 : 1 ) : new InputStatic( 'gender', this.m_Profile.Gender ? 'männlich' : 'weiblich' )
				}
			)
		);

		this.m_Inputs.push(
			form.newFormGroup( [ 1 ] ).addItem(
				{
					label: new InputLabel( { value: 'Personalnummer' } ),
					input: new InputStatic( 'staff_number', this.m_Profile.StaffNumber || '----------------' )
				}
			)
		);

		return form;
	}
}
